import * as React from 'react';
export const IcFlightMode = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M20.5 3.5a2 2 0 00-2.83 0L14.13 7 4.7 5.81a1.5 1.5 0 00-1 2.76L9.18 12l-1.41 1.4-3 .27a1.5 1.5 0 00-.6 2.8l2.14 1.21 1.21 2.14a1.5 1.5 0 002.8-.6l.27-3 1.41-1.4 3.42 5.47a1.5 1.5 0 002.76-1L17 9.87l3.5-3.54a1.999 1.999 0 000-2.83z'
      fill='currentColor'
    />
  </svg>
);
